import { alpha, Box, Container, Stack, Typography, useTheme } from "@mui/material";
import React from "react";
import animocaLogo from '../../image/logo/Animoca_Brands_logo.svg.png';
import varmeegoLogo from '../../image/logo/1620105971552.jpg';
import outblazeLogo from '../../image/logo/Outblaze.png';
import birdieLogo from '../../image/logo/logo.png';
import pixioLogo from '../../image/logo/pixio.jpeg';
import peplinkLogo from '../../image/logo/peplink-vector-logo.png';
import teenLogo from '../../image/original.png';
import EcoSystemSection from './section/EcoSystemSection';
import christianLogo from '../../image/logo/fba2f36a-747b-4ab5-9ac7-7487f692a2e0.jpg';
import ewalkerLogo from "../../image/logo/collaboration/ewalker.jpg";
import siremixLogo from "../../image/logo/collaboration/siremix.png";
import ienterpriseLogo from "../../image/logo/collaboration/ienterprise.png";
import bustyleLogo from "../../image/logo/collaboration/bustyle.png";

const ecoSystemData = [
  {
    title: '願景',
    description: '我們一直深信，香港資訊科技未來必須有更多的編程人才，以應對世界科技的飛速發展。',
  },
  {
    title: '使命',
    description: '我們的使命是培訓，聯繫年青人進入科技行業!',
  },
  {
    title: '目標',
    description: '我們目標提供密集、實用的培訓課程，以確保與技術環境相關的，可以進一步脫穎而出。',
  },
];

const logoList = [
  // {
  //   title: "Birdie",
  //   logo: birdieLogo,
  // },
  {
    title: "Varmeego",
    logo: varmeegoLogo,
  },
  {
    title: "Outblaze",
    logo: outblazeLogo,
  },
  {
    title: "Animoca Brands",
    logo: animocaLogo,
    p: 0,
    style: {paddingTop: 20}
  },
  {
    title: "Pixio Ltd",
    logo: pixioLogo,
    p: 5,
    style: {paddingTop: 10}
  },
  // {
  //   title: "Peplink",
  //   logo: peplinkLogo,
  // },
];

const collaborationPartnerList = [
  {
    title: "Christian Action",
    href: "https://www.cats.org.hk/digital-learning-centre/sw-testing",
    logo: christianLogo,
  },
  {
    title: "Ewalker",
    href: "https://www.ewalker.com.hk/",
    logo: ewalkerLogo,
  },
  {
    title: "Siremix",
    href: "https://www.siremix.com/",
    logo: siremixLogo,
  },
  {
    title: "IEnterprise",
    href: "https://www.ienterprise.com.hk/%e4%b8%bb%e9%a0%81/",
    logo: ienterpriseLogo,
  },
  {
    title: "Bustyle",
    href: "https://www.instagram.com/bustyle_3d/",
    logo: bustyleLogo,
  },
];

const AboutUsPage = () => {
  const color = useTheme().palette;
  const theme = useTheme();
  return (
    <Box
      sx={{
        width: 1,
        overflowX: "hidden",
        color: "primary.contrastText",
        bgcolor: alpha(color.background.default, 0.6),
        py: { xs: 6, md: 9 },
      }}
    >
      <Container maxWidth="lg" sx={{ px: { xs: 3, md: 4 } }}>
        <Stack spacing={6}>
          <Stack spacing={1.5}>
            <Typography variant="h2" sx={{ typography: { xs: "h3", md: "h2" } }}>
              關於我們
            </Typography>
            <Typography
              variant="body1"
              sx={{ color: alpha(color.primary.contrastText, 0.72), maxWidth: 980, fontWeight: theme.typography.fontWeightBold }}
            >
              Teen Future Academy（TFA）致力培訓及連繫年青人進入科技行業，讓更多熱愛 IT 的青年可在香港找到成長與發展的方向。
            </Typography>
          </Stack>

          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: { xs: "1fr", md: "minmax(0, 6fr) minmax(0, 6fr)" },
              gap: { xs: 3, md: 4 },
              alignItems: "start",
            }}
          >
            <Box
              component="img"
              src={teenLogo}
              alt="Teen Future"
              sx={{
                width: 1,
                maxHeight: { xs: 260, md: 360 },
                objectFit: "cover",
                border: `1px solid ${alpha(color.primary.contrastText, 0.12)}`,
              }}
            />
            <Stack spacing={2.25} sx={{ borderLeft: { md: `2px solid ${alpha(color.info.light, 0.6)}` }, pl: { md: 3 } }}>
              <Stack spacing={0.75}>
                <Typography variant="overline" sx={{ color: alpha(color.info.light, 0.86), letterSpacing: 0.6 }}>
                  持續存在
                </Typography>
                <Typography variant="h4" sx={{ typography: { xs: "h5", md: "h4" } }}>
                  自 2015 年起，陪伴青年踏入科技
                </Typography>
              </Stack>
              <Typography variant="body1" sx={{ color: alpha(color.primary.contrastText, 0.82), lineHeight: 1.9 }}>
                母公司 Teen Future 自 2015 年成立，累積超過 3000 名青少年參與遊戲 QA 及科技相關培訓。TFA 延伸這份使命，
                以「密集、實用、可落地」的課程設計，協助學員建立技能、作品與入行方向。
              </Typography>
              <Typography variant="body1" sx={{ color: alpha(color.primary.contrastText, 0.76), lineHeight: 1.9 }}>
                我們希望建立一個可以長期運作的學習生態：讓學員不只在課堂學到知識，而能把技能用於真實情境，透過科技影響社區，提升整體產業的生產力。
              </Typography>
            </Stack>
          </Box>

          <EcoSystemSection list={ecoSystemData} image="ecosystem.png" />

          <Stack spacing={2.5}>
            <Stack spacing={1}>
              <Typography variant="h3" sx={{ typography: { xs: "h4", md: "h3" } }}>
                策略夥伴
              </Typography>
              <Typography
                variant="body1"
                sx={{ color: alpha(color.primary.contrastText, 0.72), maxWidth: 980, fontWeight: theme.typography.fontWeightBold }}
              >
                我們與不同機構合作，提供更貼近市場與社區需要的學習機會。
              </Typography>
            </Stack>

            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: { xs: "repeat(2, minmax(0, 1fr))", sm: "repeat(3, minmax(0, 1fr))", md: "repeat(5, minmax(0, 1fr))" },
                gap: { xs: 1.5, md: 2 },
                alignItems: "start",
              }}
            >
              {logoList.map((item) => (
                <Stack
                  key={item.title}
                  spacing={1.25}
                  sx={{
                    justifyContent: "center",
                    alignItems: "center",
                    minHeight: 160,
                  }}
                >
                  <Box
                    sx={{
                      width: { xs: 190, md: 220 },
                      height: { xs: 112, md: 128 },
                      bgcolor: "common.white",
                      border: `1px solid ${alpha(color.primary.contrastText, 0.08)}`,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      boxSizing: "border-box",
                      p: 1.5,
                      overflow: "hidden",
                    }}
                  >
                    <Box
                      component="img"
                      alt={item.title}
                      src={item.logo}
                      sx={{
                        display: "block",
                        width: "100%",
                        height: "100%",
                        maxWidth: "100%",
                        maxHeight: "100%",
                        objectFit: "contain",
                        objectPosition: "center",
                        filter: "saturate(0.95)",
                      }}
                    />
                  </Box>
                  <Typography variant="body2" sx={{ color: alpha(color.primary.contrastText, 0.78) }}>
                    {item.title}
                  </Typography>
                </Stack>
              ))}
            </Box>
          </Stack>

          <Stack spacing={2.5}>
            <Stack spacing={1}>
              <Typography variant="h3" sx={{ typography: { xs: "h4", md: "h3" } }}>
                合作夥伴
              </Typography>
              <Typography
                variant="body1"
                sx={{ color: alpha(color.primary.contrastText, 0.72), maxWidth: 980, fontWeight: theme.typography.fontWeightBold }}
              >
                我們與社區及企業夥伴共同推動更多實踐機會，讓學習連結真實世界。
              </Typography>
            </Stack>

            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: { xs: "repeat(2, minmax(0, 1fr))", sm: "repeat(3, minmax(0, 1fr))", md: "repeat(5, minmax(0, 1fr))" },
                gap: { xs: 1.5, md: 2 },
                alignItems: "start",
              }}
            >
              {collaborationPartnerList.map((item) => (
                <Stack
                  key={item.title}
                  component="a"
                  href={item.href}
                  target="_blank"
                  rel="noreferrer noopener"
                  spacing={1.25}
                  sx={{
                    justifyContent: "center",
                    alignItems: "center",
                    minHeight: 160,
                    textDecoration: "none",
                    color: "inherit",
                    "&:hover img": {
                      filter: "saturate(1)",
                    },
                    "&:focus-visible": {
                      outline: `2px solid ${alpha(color.info.light, 0.6)}`,
                      outlineOffset: 3,
                    },
                  }}
                >
                  <Box
                    sx={{
                      width: { xs: 190, md: 220 },
                      height: { xs: 112, md: 128 },
                      bgcolor: "common.white",
                      border: `1px solid ${alpha(color.primary.contrastText, 0.08)}`,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      boxSizing: "border-box",
                      p: 1.5,
                      overflow: "hidden",
                    }}
                  >
                    <Box
                      component="img"
                      alt={item.title}
                      src={item.logo}
                      sx={{
                        display: "block",
                        width: "100%",
                        height: "100%",
                        maxWidth: "100%",
                        maxHeight: "100%",
                        objectFit: "contain",
                        objectPosition: "center",
                        filter: "saturate(0.95)",
                      }}
                    />
                  </Box>
                  <Typography variant="body2" sx={{ color: alpha(color.primary.contrastText, 0.78) }}>
                    {item.title}
                  </Typography>
                </Stack>
              ))}
            </Box>
          </Stack>
        </Stack>
      </Container>
    </Box>
  );
};

export default AboutUsPage;
